export const APP_NAME = 'atvn-customer';
export const APP_PREFIX_PATH = '/app';
export const CUSTOMER_PREFIX_PATH = '/customer';
export const AUTH_PREFIX_PATH = '/auth';